import { cn } from "@/lib/utils"
import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"
import { RaisyLogoLoader } from "@/components/loading/RaisyLogoLoader"
import React from "react"

const spinnerVariants = cva("flex-col items-center justify-center", {
  variants: {
    show: {
      true: "flex",
      false: "hidden",
    },
  },
  defaultVariants: {
    show: true,
  },
})

const SIZE_MAP: Record<string, number> = {
  small: 16,
  medium: 24,
  large: 40,
}

interface SpinnerContentProps
  extends VariantProps<typeof spinnerVariants> {
  size?: "small" | "medium" | "large"
  className?: string
  children?: React.ReactNode
}

export function Spinner({
  size = "medium",
  show,
  children,
  className,
}: SpinnerContentProps) {
  return (
    <span className={cn(spinnerVariants({ show }), className)}>
      <RaisyLogoLoader
        size={SIZE_MAP[size] ?? SIZE_MAP.medium}
        color="#0ab3bf"
        speed={1.17}
        stroke={4}
        strokeLength={0.2}
        bgOpacity={0.15}
      />
      {children}
    </span>
  )
}
